// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Nfsm","name":"Header_name__13bmU","birthday":"Header_birthday__2sqNG","skeleton":"Header_skeleton__3eVEx"};